export enum LineNumber {
    LINE1 = 1,
    LINE2 = 2,
}
